 
export const environment = {
  production: false,
  allowedHosts: ['levante.test.dcs.comitas.com', 'levante.test.dcs.comitas.ch']
};
